export default __webpack_public_path__ + "static/media/cl.9ca8cc2d.svg";